import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

import { addErrorNotification } from "../notifications/actions"
import { scriptingAPI } from "../../apis"
import { RequestErrorDataApi } from "../../errors"
import { Exceptions } from "../../util/Translations"
import { formatLabel } from "../../util/Strings"

export const scriptingSlice = createSlice({
    name: "scripting",

    initialState: {},
    reducers: {},
})

export default scriptingSlice.reducer

export interface ExecuteActionParameters {
    action: string
    conceptId?: number
    itemId?: number
    fieldId?: string
}

export const executeAction = createAsyncThunk(
    "scripting/executeAction",
    async (
        { action, conceptId, itemId, fieldId }: ExecuteActionParameters,
        { getState: _getState, dispatch },
    ) => {
        try {
            const { scriptId, listScriptId, hasParameters } =
                await scriptingAPI.getScriptInformation(
                    action,
                    conceptId,
                    itemId,
                )

            return scriptingAPI.executeScript({
                scriptId,
                listScriptId,
                hasParams: hasParameters,
                itemId,
                cFieldId: Number.parseInt((fieldId ?? "").slice(2)),
            })
        } catch (error) {
            let errorMessage = formatLabel(
                Exceptions.AnErrorOccurredWhileExecutingAction,
                action,
            )
            console.error(`${errorMessage}`, error)
            if (error instanceof RequestErrorDataApi) {
                errorMessage = `${error.message}`
            } else if (error instanceof Error) {
                errorMessage = `${errorMessage}. ${error.message}`
            }
            dispatch(addErrorNotification(errorMessage))
        }
    },
)
